import styles from "./KlashaSelect.module.css";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

interface KlashaSelectProps {
  required?: boolean;
  inputId?: string;
  label: string;
  placeholder?: string | null;
  onChange: (option: any) => void;
  options: Option[];
  defaultValue?: Option;
}

export const KlashaSelect = ({
  label,
  options,
  inputId,
  placeholder = null,
  required = false,
  defaultValue,
  onChange,
}: KlashaSelectProps) => {
  const customStyles = {
    menuList: (provided: any) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    }),
    control: (provided: any) => ({
      ...provided,
      borderRadius: "none",
      fontSize: 14,
      border: "none",
      outline: "none",
      boxShadow: "none",
      paddingLeft: 0,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: "none",
    }),
  };

  return (
    <div className={styles.container}>
      <label>
        {label} {required && <span>*</span>}
      </label>
      <Select
        styles={customStyles}
        className={styles.select}
        options={options}
        onChange={onChange}
        defaultValue={defaultValue}
      />
    </div>
  );
};
